<!--
 * @Description: 合作伙伴详情
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-02-22 09:47:42
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content :loading="loading">
      <CosViewContent
        header
        :title="data?.customerInfo?.customerName"
        :sellerName="data?.customerInfo?.sellerName"
        :collection-id="data?.collectionId"
        customLabel="主客户代码"
        :customValue="data?.customerInfo?.customerNumber"
        :add-fav="addFavorite"
        :cancel-fav="cancelFavorite"
        :turnedContract="data?.customerInfo?.turnedContract"
        :turnedPotential="data?.customerInfo?.turnedPotential"
        :turnedTransaction="data?.customerInfo?.turnedTransaction"
      >
        <a-tabs @change="changeTabs" v-model:activeKey="activeKey">
          <a-tab-pane key="base" tab="基本信息">
            <baseMessage :disabled="true" formItemView :data="data" type="contract" :permissionPage="permissionBasic" />
          </a-tab-pane>
          <a-tab-pane key="contact" tab="联系人">
            <TabsContacts ref="contactsRef" :contactRefId="route.query.cosId" :permissionPage="permissionConcat" />
          </a-tab-pane>
          <a-tab-pane key="3" tab="跟进记录">
            <TabsClueCosFollowUp
              :showFooter="true"
              :followRefId="route.query.cosId"
              :permissionPage="permissionFollow"
            />
          </a-tab-pane>
          <a-tab-pane key="4" tab="商机">
            <tabsBusiness :permissionPage="permissionBuss" />
          </a-tab-pane>
          <a-tab-pane key="5" tab="合同信息">
            <tabsContract />
          </a-tab-pane>
          <a-tab-pane key="6" tab="转化记录">
            <tabsConversion :resourceId="route.query.cosId" />
          </a-tab-pane>
          <a-tab-pane key="operationLog" tab="操作日志">
            <TabsOperationLog ref="operationLogRef" tableId="FbuContractOperationLog" :resourceId="route.query.cosId" appId="cos_fbu" />
          </a-tab-pane>
          <a-tab-pane key="8" tab="客户代码">
            <tabsCode />
          </a-tab-pane>
          <a-tab-pane key="9" tab="签约主体">
            <tabsMainBody />
          </a-tab-pane>
        </a-tabs>
      </CosViewContent>
      <ViewFooterBtn
        :permissionPage="permissionBasic"
        @success="footerSuccess"
        :loading="loading"
        type="contract"
        :data="data.customerInfo"
        :isPublicClue="isPublicClue === '1'"
        :workCode="data?.customerInfo?.seller"
      />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import TabsConversion from '@/components/TabsConversion'
import TabsClueCosFollowUp from '@/components/TabsClueCosFollowUp'
import TabsContacts from '@/components/TabsContacts/index.vue'
import baseMessage from '@/views/gucangSales/customerCenter/components/baseMessage.vue'
import tabsContract from '@/views/gucangSales/customerCenter/components/tabsContract.vue'
import ViewFooterBtn from '@/views/gucangSales/customerCenter/components/viewFooterBtn.vue'
import tabsCode from '@/views/gucangSales/customerCenter/components/tabsCode.vue'
import tabsBusiness from '@/views/gucangSales/customerCenter/components/tabsBusiness.vue'
import tabsMainBody from '@/views/gucangSales/customerCenter/components/tabsMainBody.vue'
import { potentialDetail } from '@/api/gucangSales/customerCenter'
import { useRoute } from 'vue-router'
import { addToFav, cancelToFav } from '@/api/common'
const route = useRoute()
const data = ref({})
const operationLogRef = ref()
const contactsRef = ref()
const loading = ref(false)
const activeKey = ref('base')
const isPublicClue = computed(() => route.query.isPublicClue) // 是否是从公海池过来的
// 获取详情
const fetch = () => {
  if (route.query.cosId) {
    loading.value = true
    potentialDetail(route.query.cosId)
      .then((res) => {
        data.value = res.data
      })
      .finally(() => {
        loading.value = false
      })
  }
}
// 标签页切换
const changeTabs = (v: string) => {
  if (v === 'base') {
    fetch()
  } else if (v === 'operationLog') {
    // 更新联系人或者操作日志
    if (activeKey.value === 'contact') {
      contactsRef.value?.refresh()
    } else if (activeKey.value === 'operationLog') {
      operationLogRef.value?.fetch()
    }
  }
}
// 收藏
const addFavorite = () => {
  addToFav({
    appId: 'cos_fbu',
    cosId: data.value.customerInfo.cosId,
    stage: 3
  }).then((res) => {
    if (res.code === 200) {
      data.value.collectionId = data.value.customerInfo.cosId
    }
  })
}
// 收藏
const cancelFavorite = () => {
  cancelToFav({
    appId: 'cos_fbu',
    cosId: data.value.customerInfo.cosId,
    stage: 3
  }).then((res) => {
    if (res.code === 200) {
      data.value.collectionId = null
      data.value.collectionTime = null
    }
  })
}
const permissionBasic = {
  transfer: 'fbu_contract_transfer_btn',
  follow_add: 'fbu_contract_follow_add_btn',
  visitor_add: 'fbu_contract_visitori_add_btn',
  edit: 'fbu_contract_edit_btn',
  buss_add: 'fbu_contract_buss_add_btn',
  concat_add: 'fbu_contract_concat_add_btn'
}
const permissionFollow = {
  edit: 'fbu_contract_follow_edit_btn',
  del: 'fbu_contract_follow_del_btn',
  comment: 'fbu_contract_follow_comment_btn'
}
const permissionBuss = {
  edit: 'fbu_contract_buss_edit_btn',
  del: 'fbu_contract_buss_del_btn'
}
const permissionConcat = {
  edit: 'fbu_contract_concat_edit_btn',
  del: 'fbu_contract_concat_del_btn',
  isPublic: isPublicClue.value === '1'
}
const footerSuccess = (tag: 'base' | 'contact') => {
  if (tag === 'base') {
    fetch()
  } else if (tag === 'contact') {
    contactsRef.value?.refresh()
  }
}
onMounted(() => {
  fetch()
})
</script>
<script lang="ts">
export default {
  name: 'FbuContractView'
}
</script>
<style lang="scss" scoped></style>
